<template>
  <template-list
    :me="me"
    :loading="$apollo.queries.templates.loading"
    :templates="templates"
    @onSave="handleOnSave($event)"
    @onDelete="handleOnDelete($event)"
  >
  </template-list>
</template>

<script>
import { mapState } from 'vuex';

import TemplateList from '@/components/automatedemails/templates/TemplateList';
import emailTemplateListQuery from '@/graphql/automatedemails/templates/emailTemplateList.gql';
import updateEmailTemplateMutation from '@/graphql/automatedemails/templates/emailTemplateUpdateMutation.gql';

export default {
  name: 'EmailDashboardContainer',
  components: {
    TemplateList,
  },
  apollo: {
    $client: 'apiv2',
    templates: {
      query: emailTemplateListQuery,
      prefetch: true,
    },
  },
  computed: {
    ...mapState('user', ['me']),
  },
  mounted() {
    this.$apollo.queries.templates.refetch();
  },
  methods: {
    redirect() {
      this.$notify({
        title: 'Success!',
        message: 'Email successfully created!',
        type: 'success',
      });

      this.$router.push({ path: '/admin/templates' });
    },
    handleOnSave(email) {
      this.$apollo
        .mutate({
          client: 'apiv2',
          mutation: updateEmailTemplateMutation,
          variables: { ...email },
        })
        .then(() => this.redirect())
        .catch(err => this.$message.error(`Something went wrong -- ${err.message}`));
    },
  },
};
</script>



// WEBPACK FOOTER //
// EmailDashboardContainer.vue?478692ce